import React, { useState, useEffect, useRef } from "react";
import Sidebar from '../../composant_reutilisable/sidebar';
import Navbar from "../../composant_reutilisable/navbar";
import useAuth from '../../composant_reutilisable/useAuth';
import { Link, useNavigate } from "react-router-dom";
import { FaPlus, FaShieldAlt, FaSortAmountUp, FaSortAmountDown, FaArrowLeft, FaArrowRight, FaCaretDown, FaEllipsisV, FaAngleDoubleLeft, FaAngleDoubleRight, FaFileAlt, FaChevronUp, FaChevronDown, FaEdit, FaSearch, FaQuestionCircle } from "react-icons/fa";
import { Modal, Button, Spinner, Dropdown } from "react-bootstrap";
import axios from 'axios';
import Select from "react-select";
import { FaArrowRotateLeft } from "react-icons/fa6";
import GlossaireSidebar from '../../composant_reutilisable/glossaireSidebar';
import Footer from "../../composant_reutilisable/footer";

const Listes_pieces = ({ titre }) => {
    useAuth();
    const user_id = localStorage.getItem("userId");
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingPieces, setIsLoadingPieces] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'ascending' });
    const navigate = useNavigate();

    const [showInfo, setShowInfo] = useState(true);

    useEffect(() => {
        if (user_id) {
            document.title = "Transportpro | Suivi Documents Administration";
        }
    }, [user_id]);

    // États
    const [userData, setUserData] = useState({});

    // États pour la recherche et la pagination
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);

    // État pour suivre l'utilisateur sélectionné
    const [deletePiece, setDeletePiece] = useState(null);

    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
        }, 3000);
    };

    // Récupérer les données de l'utilisateur
    useEffect(() => {
        const fetchUserData = async () => {
            try {
                setIsLoading(true);
                const response = await fetch(process.env.REACT_APP_HOTE + `/recup-info-profil/${user_id}/`);
                if (response.ok) {
                    const data = await response.json();
                    setUserData(data);
                    console.log("userData", data);
                }
                setIsLoading(false);
            } catch (error) {
                setIsLoading(false);
                console.error("Erreur lors de la récupération du profil:", error);
            }
        };

        fetchUserData();
    }, [user_id]);

    const DocumentViewerHistorique = ({ fileUrl, fileType, fileName }) => {
        const [isLoading, setIsLoading] = useState(true);
        const [error, setError] = useState(null);
        const [objectUrl, setObjectUrl] = useState(null);
        console.log("historique view", fileUrl, fileType, fileName);

        // Déduire le type de fichier si non fourni
        const getFileType = (url) => {
            if (!url) return null;
            const extension = url.split('.').pop().split('?')[0].toLowerCase();
            if (extension === 'pdf') return 'pdf';
            if (['jpg', 'jpeg', 'png', 'gif'].includes(extension)) return 'image';
            return null;
        };

        const determinedFileType = fileType || getFileType(fileUrl);

        const displayUrl = objectUrl || fileUrl;

        return (
            <div className="document-viewer" style={{
                height: '500px',
                border: '1px solid #ddd',
                borderRadius: '5px',
                position: 'relative'
            }}>
                {isLoading && (
                    <div className="d-flex justify-content-center align-items-center" style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(255,255,255,0.8)'
                    }}>
                        <Spinner animation="border" />
                        <span className="ms-2">Chargement du document...</span>
                    </div>
                )}

                {determinedFileType === 'pdf' && (
                    <iframe
                        src={displayUrl}
                        style={{
                            width: '100%',
                            height: '100%',
                            display: isLoading ? 'none' : 'block',
                            border: 'none'
                        }}
                        onLoad={() => setIsLoading(false)}
                        onError={() => {
                            setError("Impossible de charger le PDF");
                            setIsLoading(false);
                        }}
                        title={fileName || "Document PDF"}
                    />
                )}

                {determinedFileType === 'image' && (
                    <img
                        src={displayUrl}
                        alt={fileName || "Document"}
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain',
                            display: isLoading ? 'none' : 'block'
                        }}
                        onLoad={() => setIsLoading(false)}
                        onError={() => {
                            setError("Impossible de charger l'image");
                            setIsLoading(false);
                        }}
                    />
                )}

                {error && (
                    <div className="d-flex justify-content-center align-items-center" style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0
                    }}>
                        <p className="text-danger">{error}</p>
                    </div>
                )}

                {!determinedFileType && !isLoading && !error && (
                    <div className="d-flex justify-content-center align-items-center" style={{ height: '100%' }}>
                        <p>Format de document non supporté</p>
                    </div>
                )}
            </div>
        );
    };

    const handleDateChange = (e, pieceId) => {
        const { name, value } = e.target;

        setPiecesFormData(prev => ({
            ...prev,
            [pieceId]: {
                ...prev[pieceId],
                [name]: value
            }
        }));
    };

    const handleFileChange = (e, pieceId) => {
        const file = e.target.files[0];
        if (file) {
            const previewUrl = URL.createObjectURL(file);
            setPiecesFormData(prev => ({
                ...prev,
                [pieceId]: {
                    ...prev[pieceId],
                    fichier: file,
                    previewUrl: previewUrl
                }
            }));
        }
    };


    const DocumentViewerRenouveler = ({ fileUrl, fileType, fileName }) => {
        const [isLoadingRenouveler, setIsLoadingRenouveler] = useState(true);
        const [error, setError] = useState(null);
        const [objectUrl, setObjectUrl] = useState(null);

        // Gestion des URLs blob
        useEffect(() => {
            // Si c'est une URL blob, on la conserve
            if (fileUrl && fileUrl.startsWith('blob:')) {
                setObjectUrl(fileUrl);
            } else {
                setObjectUrl(null);
            }

            return () => {
                // Nettoyage des URL blob seulement si c'est nous qui l'avons créée
                if (objectUrl && objectUrl.startsWith('blob:')) {
                    URL.revokeObjectURL(objectUrl);
                }
            };
        }, [fileUrl]);

        const displayUrl = objectUrl || fileUrl;

        return (
            <div className="document-viewer" style={{
                height: '500px',
                border: '1px solid #ddd',
                borderRadius: '5px',
                position: 'relative'
            }}>
                {isLoadingRenouveler && (
                    <div className="d-flex justify-content-center align-items-center" style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0
                    }}>
                        <Spinner animation="border" />
                        <span className="ms-2">Chargement du document...</span>
                    </div>
                )}

                {fileType?.includes('pdf') && (
                    <iframe
                        src={displayUrl}
                        style={{
                            width: '100%',
                            height: '100%',
                            display: isLoadingRenouveler ? 'none' : 'block',
                            border: 'none'
                        }}
                        onLoad={() => setIsLoadingRenouveler(false)}
                        onError={() => {
                            setError("Impossible de charger le PDF");
                            setIsLoadingRenouveler(false);
                        }}
                        title={fileName || "Document PDF"}
                    />
                )}

                {fileType?.includes('image') && (
                    <img
                        src={displayUrl}
                        alt={fileName || "Document"}
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain',
                            display: isLoadingRenouveler ? 'none' : 'block'
                        }}
                        onLoad={() => setIsLoadingRenouveler(false)}
                        onError={() => {
                            setError("Impossible de charger l'image");
                            setIsLoadingRenouveler(false);
                        }}
                    />
                )}

                {error && (
                    <div className="d-flex justify-content-center align-items-center" style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0
                    }}>
                        <p className="text-danger">{error}</p>
                    </div>
                )}

                {!fileType && !isLoadingRenouveler && !error && (
                    <div className="d-flex justify-content-center align-items-center" style={{ height: '100%' }}>
                        <p>Format de document non supporté</p>
                    </div>
                )}
            </div>
        );
    };

    const [listePiece, setListePiece] = useState([
        // { id: 1, type_piece: "Carte grise", version: "1", fin_validite: "2025-06-12", jours_restants: 450, numero_immatriculation: "AA-123-BB", proprietaire: "Jean Dupont", telephone: "0601020304", statut: "Valide" },
        // { id: 2, type_piece: "Permis de conduire", version: "2", fin_validite: "2024-12-01", jours_restants: 300, numero_immatriculation: "BB-456-CC", proprietaire: "Marie Curie", telephone: "0605060708", statut: "Expiré" },
    ]);

    const fetchPieces = async () => {
        try {
            setIsLoadingPieces(true);
            const response = await axios.get(`${process.env.REACT_APP_HOTE}/liste-vehicules-pieces/`);

            if (!response.data.success) {
                throw new Error(response.data.message || "Erreur lors de la récupération des données");
            }
            console.log("vehiculesData", response.data.data);

            // Formatage simple des données reçues
            // const formattedData = response.data.data.map(vehicule => ({
            //     ...vehicule,
            //     pieces: vehicule.pieces_expirables,
            // }));

            setListePiece(response.data.data);
            // console.log("formattedData", formattedData);
        } catch (error) {
            console.error("Erreur lors de la récupération des pièces:", error);
            showAlert(
                error.response?.data?.message ||
                error.message ||
                "Erreur lors du chargement des pièces",
                "danger"
            );
        } finally {
            setIsLoadingPieces(false);
        }
    };

    useEffect(() => {
        console.log("Exécution de useEffect...");
        fetchPieces();
    }, []);

    // const renderPieceCell = (vehicule, typePiece) => {
    //     if (!vehicule.pieces_expirables || !Array.isArray(vehicule.pieces_expirables)) {
    //       return '-';
    //     }

    //     const piece = vehicule.pieces_expirables.find(p => p.type_piece === typePiece);
    //     if (!piece) return '-';

    //     if (!piece.fin_validite) {
    //       return <span className="text-muted">Non défini</span>;
    //     }

    //     // Calculer les jours restants à chaque rendu pour être précis
    //     const aujourdHui = new Date();
    //     aujourdHui.setHours(0, 0, 0, 0);

    //     try {
    //       const [day, month, year] = piece.fin_validite.split('/');
    //       const finValidite = new Date(`${year}-${month}-${day}`);
    //       const differenceJours = Math.floor((finValidite - aujourdHui) / (1000 * 60 * 60 * 24));

    //       if (differenceJours < 0) {
    //         return <span className="badge badge-danger">Expirée</span>;
    //       }
    //       if (differenceJours === 0) {
    //         return <span className="badge badge-warning">Ce jour</span>;
    //       }
    //       if (differenceJours === 1) {
    //         return <span className="badge badge-warning">Demain</span>;
    //       }
    //       if (differenceJours <= 30) {
    //         return <span className="badge badge-warning">{differenceJours} jours</span>;
    //       }
    //       return <span className="badge badge-primary">Valide</span>;

    //     } catch (e) {
    //       console.error("Erreur de date", piece.fin_validite);
    //       return <span className="text-danger">Erreur date</span>;
    //     }
    //   };
    const renderPieceCell = (vehicule, typePiece) => {
        if (!vehicule.pieces_expirables || !Array.isArray(vehicule.pieces_expirables)) {
            return '-';
        }

        const piece = vehicule.pieces_expirables.find(p => p.type_piece === typePiece);
        if (!piece) return '-';

        if (!piece.fin_validite) {
            return <span className="text-muted">Non défini</span>;
        }

        // Calculer les jours restants pour le tri
        const aujourdHui = new Date();
        aujourdHui.setHours(0, 0, 0, 0);

        try {
            const [day, month, year] = piece.fin_validite.split('/');
            const finValidite = new Date(`${year}-${month}-${day}`);
            const differenceJours = Math.floor((finValidite - aujourdHui) / (1000 * 60 * 60 * 24));

            // Retourner le badge approprié
            if (differenceJours < 0) {
                return <span className="badge badge-danger">Expirée</span>;
            }
            if (differenceJours === 0) {
                return <span className="badge badge-warning">Ce jour</span>;
            }
            if (differenceJours === 1) {
                return <span className="badge badge-warning">Demain</span>;
            }
            if (differenceJours <= 30) {
                return <span className="badge badge-warning">{differenceJours} jours</span>;
            }
            return <span className="badge badge-primary">Valide</span>;

        } catch (e) {
            console.error("Erreur de date", piece.fin_validite);
            return <span className="text-danger">Erreur date</span>;
        }
    };


    const piecesAActions = (piece) => {
        // Utilise directement le flag est_expirable du backend si disponible
        if (piece.est_expirable !== undefined) return piece.est_expirable;

        // Sinon, logique de fallback
        if (!piece.fin_validite) return false;

        const aujourdHui = new Date();
        aujourdHui.setHours(0, 0, 0, 0);

        try {
            const finValidite = new Date(piece.fin_validite);
            return finValidite < aujourdHui;
        } catch (e) {
            console.error("Erreur de date", piece.fin_validite);
            return false;
        }
    };

    // const vehiculeAPiecesExpirees = (vehicule) => {
    //     // Vérifie simplement s'il y a des pièces expirables
    //     return vehicule.pieces_expirables && vehicule.pieces_expirables.length > 0;
    // };
    const vehiculeAPiecesExpirees = (vehicule) => {
        if (!vehicule.pieces_expirables) return false;

        const aujourdHui = new Date();
        aujourdHui.setHours(0, 0, 0, 0);

        return vehicule.pieces_expirables.some(piece => {
            if (!piece.fin_validite) return false;

            try {
                const finValidite = new Date(piece.fin_validite);
                return finValidite < aujourdHui;
            } catch (e) {
                console.error("Erreur de date", piece.fin_validite);
                return false;
            }
        });
    };

    const [currentFilter, setCurrentFilter] = useState("");

    const handleFilterClick = (status) => {
        setCurrentFilter(status);
        setCurrentPage(1); // Réinitialiser à la première page lors du changement de filtre
    };

    const [proprietaires, setProprietaires] = useState([]);
    useEffect(() => {
        const fetchProprietaires = async () => {
            try {
                const response = await fetch(process.env.REACT_APP_HOTE + "/liste-proprietaires/");
                if (response.ok) {
                    const data = await response.json();
                    if (data.success) {
                        setProprietaires(data.data);
                    }
                    // console.log("Propriétaires reçus:", data.data);
                }
            } catch (error) {
                console.error("Erreur lors de la récupération des propriétaires:", error);
            }
        };

        fetchProprietaires();
    }, []);
    
    const [immatriculations, setImmatriculations] = useState([]);

    useEffect(() => {
        const fetchImmatriculations = async () => {
            try {
                const response = await fetch(process.env.REACT_APP_HOTE + "/liste-immatriculations/");
                if (response.ok) {
                    const data = await response.json();
                    if (data.success) {
                        setImmatriculations(data.data);
                    }
                }
            } catch (error) {
                console.error("Erreur lors de la récupération des immatriculations:", error);
            }
        };

        fetchImmatriculations();
    }, []);

    const [typePieceOptions, setTypePieceOptions] = useState([]);
    useEffect(() => {
        axios.get(process.env.REACT_APP_HOTE + "/liste-types-pieces/")
            .then(res => {
                const options = res.data.types.map(t => ({
                    value: t,
                    label: t
                }));
                setTypePieceOptions(options);
            })
            .catch(err => {
                console.error("Erreur lors du chargement des types de pièce :", err);
            });
    }, []);

    // États pour la recherche avancée
    const [showAdvancedSearch, setShowAdvancedSearch] = useState(false);
    const [searchParams, setSearchParams] = useState({
        type_piece: [],
        type_carte: '',
        version: '',
        numero_immatriculation: '',
        date_debut: '',
        date_fin: '',
        fin_validite: '',
        proprietaire: [],
        telephone: '',
        statut: '',
        numero_piece: '',
        jours_restants: '',
        marque_vehicule: '',
        date_circulation: ''
    });
    const options = proprietaires.map(p => ({
        value: `${p.nom} ${p.prenoms}`,
        label: `${p.nom} ${p.prenoms}`
    }));

    const handleAdvancedSearchOpen = () => {
        setShowAdvancedSearch(true);
    };

    const handleAdvancedSearchClose = () => {
        setShowAdvancedSearch(false);
    };

    const handleSearchParamChange = (e) => {
        const { name, value } = e.target;
        setSearchParams({
            ...searchParams,
            [name]: value
        });
    };

    const hasActiveFilters = () => {
        // Vérifie si au moins un champ de searchParams a une valeur non vide/nulle
        const hasSearchParams = Object.entries(searchParams).some(([key, value]) => {
            // Pour les tableaux (comme type_piece qui est un multi-select)
            if (Array.isArray(value)) {
                return value.length > 0;
            }
            // Pour les autres champs
            return value !== '' && value !== null && value !== undefined;
        });

        return hasSearchParams || currentFilter !== "" || searchTerm !== "";
    };

    const [isSearching, setIsSearching] = useState(false);

    // const handleAdvancedSearchSubmit = async () => {
    //     try {
    //         setIsSearching(true);
    //         setIsLoadingPieces(true);

    //         const response = await axios.post(
    //             `${process.env.REACT_APP_HOTE}/recherche-avancee-pieces/`,
    //             {
    //                 date_debut: searchParams.date_debut,
    //                 date_fin: searchParams.date_fin
    //             }
    //         );

    //         if (response.data.success) {
    //             // La réponse contient maintenant des véhicules avec leurs pièces
    //             setListePiece(response.data.data);
    //             console.log("recherche avancee", response.data.data)
    //             setShowAdvancedSearch(false);
    //             setCurrentPage(1);
    //         } else {
    //             throw new Error(response.data.message || "Erreur lors de la recherche");
    //         }
    //     } catch (error) {
    //         console.error("Erreur lors de la recherche avancée:", error);
    //         showAlert(error.message || "Erreur lors de la recherche", "danger");
    //     } finally {
    //         setIsSearching(false);
    //         setIsLoadingPieces(false);
    //     }
    // };
    const handleAdvancedSearchSubmit = async () => {
        try {
            setIsSearching(true);
            setIsLoadingPieces(true);

            // Préparer les paramètres de recherche
            const params = {
                date_debut: searchParams.date_debut,
                date_fin: searchParams.date_fin,
                numero_immatriculation: searchParams.numero_immatriculation,
                proprietaire: searchParams.proprietaire
            };

            const response = await axios.post(
                `${process.env.REACT_APP_HOTE}/recherche-avancee-pieces/`,
                params
            );

            if (response.data.success) {
                setListePiece(response.data.data);
                console.log("recherche avancee", response.data.data);
                setShowAdvancedSearch(false);
                setCurrentPage(1);
            } else {
                throw new Error(response.data.message || "Erreur lors de la recherche");
            }
        } catch (error) {
            console.error("Erreur lors de la recherche avancée:", error);
            showAlert(error.message || "Erreur lors de la recherche", "danger");
        } finally {
            setIsSearching(false);
            setIsLoadingPieces(false);
        }
    };

    // Fonction pour réinitialiser la recherche
    // const handleResetSearch = async () => {
    //     setSearchParams({
    //         type_piece: '',
    //         type_carte: '',
    //         version: '',
    //         numero_immatriculation: '',
    //         fin_validite: '',
    //         proprietaire: '',
    //         telephone: '',
    //         statut: '',
    //         numero_piece: '',
    //         jours_restants: '',
    //         marque_vehicule: '',
    //         date_circulation: ''
    //     });
    //     setCurrentFilter("");
    //     setSearchTerm("");
    //     setCurrentPage(1);
    //     await fetchPieces(); // Recharger toutes les pièces sans filtre
    // };
    const handleResetSearch = async () => {
        setSearchParams({
            type_piece: [],
            type_carte: '',
            version: '',
            numero_immatriculation: '',
            date_debut: '',
            date_fin: '',
            fin_validite: '',
            proprietaire: [],
            telephone: '',
            statut: '',
            numero_piece: '',
            jours_restants: '',
            marque_vehicule: '',
            date_circulation: ''
        });
        setCurrentFilter("");
        setSearchTerm("");
        setCurrentPage(1);
        await fetchPieces();
    };


    const filteredPieces = listePiece.filter(vehicule => {
        // Filtre par utilisateur connecté
        // if (vehicule.ajoute_par !== userData.nom + " " + userData.prenoms) {
        //     return false;
        // }
        // console.log("vehicule.ajoute_par", vehicule.ajoute_par)

        // Filtre de recherche
        const searchTermLower = searchTerm.toLowerCase();

        // Vérifier si le véhicule ou ses pièces correspondent à la recherche
        const vehiculeMatchesSearch =
            (vehicule.numero_immatriculation && vehicule.numero_immatriculation.toLowerCase().includes(searchTermLower)) ||
            (vehicule.proprietaire?.nom_complet && vehicule.proprietaire.nom_complet.toLowerCase().includes(searchTermLower)) ||
            (vehicule.proprietaire?.telephone && vehicule.proprietaire.telephone.includes(searchTerm));

        // Si pas de filtre de date, retourner les matches de recherche
        if (!currentFilter) return vehiculeMatchesSearch;

        // Vérifier si le véhicule a des pièces qui correspondent au filtre temporel
        if (!vehicule.pieces_expirables || !Array.isArray(vehicule.pieces_expirables)) {
            return false;
        }

        const aujourdHui = new Date();
        aujourdHui.setHours(0, 0, 0, 0);

        const hasMatchingPieces = vehicule.pieces_expirables.some(piece => {
            if (!piece.fin_validite) return false;

            try {
                const [day, month, year] = piece.fin_validite.split('/');
                const finValidite = new Date(`${year}-${month}-${day}`);
                finValidite.setHours(0, 0, 0, 0);

                const differenceJours = Math.floor((finValidite - aujourdHui) / (1000 * 60 * 60 * 24));

                switch (currentFilter) {
                    case "7jrs":
                        return differenceJours >= 0 && differenceJours <= 7;
                    case "15jrs":
                        return differenceJours >= 0 && differenceJours <= 15;
                    case "30jrs":
                        return differenceJours >= 0 && differenceJours <= 30;
                    case "expiree":
                        return differenceJours < 0;
                    default:
                        return true;
                }
            } catch (e) {
                console.error("Erreur de traitement de date:", piece.fin_validite, e);
                return false;
            }
        });

        return vehiculeMatchesSearch && hasMatchingPieces;
    });

    // const filteredPieces = listePiece.filter(vehicule => {
    //     const searchTermLower = searchTerm.toLowerCase();
    //     const aujourdHui = new Date();
    //     aujourdHui.setHours(0, 0, 0, 0);

    //     // Fonction pour vérifier si une pièce correspond à un mot-clé temporel
    //     const matchesValidityKeyword = (piece) => {
    //       if (!piece.fin_validite) return false;

    //       try {
    //         const [day, month, year] = piece.fin_validite.split('/');
    //         const finValidite = new Date(`${year}-${month}-${day}`);
    //         finValidite.setHours(0, 0, 0, 0);

    //         const differenceJours = Math.floor((finValidite - aujourdHui) / (1000 * 60 * 60 * 24));

    //         if (searchTermLower.includes("valide")) {
    //           return differenceJours > 30;
    //         } else if (searchTermLower.includes("expirée") || searchTermLower.includes("expiree")) {
    //           return differenceJours < 0;
    //         }
    //       } catch (e) {
    //         console.error("Erreur de traitement de date:", piece.fin_validite, e);
    //       }
    //       return false;
    //     };

    //     // Vérifier correspondance avec les champs classiques
    //     const vehiculeMatchesSearch =
    //       (vehicule.numero_immatriculation && vehicule.numero_immatriculation.toLowerCase().includes(searchTermLower)) ||
    //       (vehicule.proprietaire?.nom_complet && vehicule.proprietaire.nom_complet.toLowerCase().includes(searchTermLower)) ||
    //       (vehicule.proprietaire?.telephone && vehicule.proprietaire.telephone.includes(searchTerm));

    //     // Si pas de filtre, juste filtre recherche
    //     if (!currentFilter) {
    //       if (["valide", "expirée", "expiree"].some(k => searchTermLower.includes(k))) {
    //         return vehicule.pieces_expirables?.some(matchesValidityKeyword);
    //       }
    //       return vehiculeMatchesSearch;
    //     }

    //     // Sinon, filtre temporel actif
    //     if (!vehicule.pieces_expirables || !Array.isArray(vehicule.pieces_expirables)) {
    //       return false;
    //     }

    //     const hasMatchingPieces = vehicule.pieces_expirables.some(piece => {
    //       if (!piece.fin_validite) return false;

    //       try {
    //         const [day, month, year] = piece.fin_validite.split('/');
    //         const finValidite = new Date(`${year}-${month}-${day}`);
    //         finValidite.setHours(0, 0, 0, 0);

    //         const differenceJours = Math.floor((finValidite - aujourdHui) / (1000 * 60 * 60 * 24));

    //         switch (currentFilter) {
    //           case "7jrs":
    //             return differenceJours >= 0 && differenceJours <= 7;
    //           case "15jrs":
    //             return differenceJours >= 0 && differenceJours <= 15;
    //           case "30jrs":
    //             return differenceJours >= 0 && differenceJours <= 30;
    //           case "expiree":
    //             return differenceJours < 0;
    //           default:
    //             return true;
    //         }
    //       } catch (e) {
    //         console.error("Erreur de traitement de date:", piece.fin_validite, e);
    //         return false;
    //       }
    //     });

    //     return vehiculeMatchesSearch && hasMatchingPieces;
    //   });


    // Pagination
    const totalItems = filteredPieces.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;

    // const sortedPieces = React.useMemo(() => {
    //     const sortableItems = [...filteredPieces];
    //     if (sortConfig.key) {
    //         sortableItems.sort((a, b) => {
    //             // Gestion spéciale pour le tri par type de pièce
    //             if (sortConfig.key.includes('piece_')) {
    //                 const pieceType = sortConfig.key.replace('piece_', '');
    //                 const pieceA = a.pieces.find(p => p.type_piece === pieceType);
    //                 const pieceB = b.pieces.find(p => p.type_piece === pieceType);

    //                 const valA = pieceA?.jours_restants ?? Infinity;
    //                 const valB = pieceB?.jours_restants ?? Infinity;

    //                 return sortConfig.direction === 'ascending' ? valA - valB : valB - valA;
    //             }

    //             // Tri normal pour les autres colonnes
    //             if (a[sortConfig.key] < b[sortConfig.key]) {
    //                 return sortConfig.direction === 'ascending' ? -1 : 1;
    //             }
    //             if (a[sortConfig.key] > b[sortConfig.key]) {
    //                 return sortConfig.direction === 'ascending' ? 1 : -1;
    //             }
    //             return 0;
    //         });
    //     }
    //     return sortableItems;
    // }, [filteredPieces, sortConfig]);

    const sortedPieces = React.useMemo(() => {
        const sortableItems = [...filteredPieces];

        if (sortConfig.key) {
            sortableItems.sort((a, b) => {
                // Tri spécial pour les colonnes de pièces
                if (sortConfig.key.startsWith('piece_')) {
                    const pieceType = sortConfig.key.replace('piece_', '');

                    // Trouver les pièces correspondantes pour chaque véhicule
                    const pieceA = a.pieces_expirables?.find(p => p.type_piece === pieceType);
                    const pieceB = b.pieces_expirables?.find(p => p.type_piece === pieceType);

                    // Valeurs pour le tri
                    const valA = pieceA?.jours_restants ?? Infinity;
                    const valB = pieceB?.jours_restants ?? Infinity;

                    return sortConfig.direction === 'ascending' ? valA - valB : valB - valA;
                }

                // Tri normal pour les autres colonnes
                if (a[sortConfig.key] < b[sortConfig.key]) {
                    return sortConfig.direction === 'ascending' ? -1 : 1;
                }
                if (a[sortConfig.key] > b[sortConfig.key]) {
                    return sortConfig.direction === 'ascending' ? 1 : -1;
                }
                return 0;
            });
        }

        return sortableItems;
    }, [filteredPieces, sortConfig]);

    useEffect(() => {
        // Réinitialiser à la première page lorsque le tri change
        setCurrentPage(1);
    }, [sortConfig]);

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    const handleSort = (key) => {
        let direction = "ascending";
        if (sortConfig.key === key && sortConfig.direction === "ascending") {
            direction = "descending";
        }
        setSortConfig({ key, direction });
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };



    const [showModal, setShowModal] = useState(false);
    const [selectedRole, setSelectedRole] = useState(""); // Stocke le rôle sélectionné

    const handleOpenModal = (n) => {
        setDeletePiece(n);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedRole(""); // Réinitialiser après fermeture
        setAlert({ message: '', type: '' });
    };


    const [showRenewModal, setShowRenewModal] = useState(false);
    const [pieceARenouveler, setPieceARenouveler] = useState(null);

    const [piecesExpirables, setPiecesExpirables] = useState([]);

    const handleCloseRenewModal = () => {
        // Nettoyer toutes les URLs blob
        Object.values(piecesFormData).forEach(data => {
            if (data.previewUrl) {
                URL.revokeObjectURL(data.previewUrl);
            }
        });
        console.log("piecesFormData", piecesFormData)

        setShowRenewModal(false);
        setPieceARenouveler(null);
        setPiecesFormData({});
    };

    // Ajoutez ces états pour gérer le formulaire
    const [formData, setFormData] = useState({
        fin_validite: '',
        fichier: null,
        previewUrl: null,
        numero_piece: ''
    });

    // Remplacer l'état formData par un état qui gère les données par pièce
    const [piecesFormData, setPiecesFormData] = useState({});

    // Initialiser les données pour chaque pièce
    const initializePieceFormData = (piece) => {
        return {
            fin_validite: '',
            fichier: null,
            previewUrl: null,
            numero_piece: '',
            type_piece: piece.type_piece,
            version: trouverDerniereVersion(piece.type_piece, piece.id_objet)
        };
    };

    // Mettre à jour lors de l'ouverture du modal
    const handleOpenRenewModal = (piece) => {
        setOpenDropdownId(null);

        // Récupérer toutes les pièces expirables
        const piecesDuVehicule = listePiece.filter(p =>
            p.numero_immatriculation === piece.numero_immatriculation
            && piecesAActions(p)
        );

        // Initialiser les données pour chaque pièce
        const initialFormData = {};
        piecesDuVehicule.forEach(p => {
            initialFormData[p.id] = initializePieceFormData(p);
        });
        console.log("pieces du vehicule à renou", listePiece);

        setPiecesFormData(initialFormData);
        setPiecesExpirables(piecesDuVehicule);
        setPieceARenouveler(piecesDuVehicule[0]); // Sélectionner la première par défaut
        setShowRenewModal(true);
    };

    const formatImmatriculation = (value) => {
        // Supprime tous les espaces et convertit en majuscules
        return value.replace(/\s/g, '').toUpperCase();
    };

    const handleImmatriculationChange = (e) => {
        const formattedValue = formatImmatriculation(e.target.value);
        // Utilisez cette fonction pour mettre à jour l'état
        setSearchParams({
            ...searchParams,
            numero_immatriculation: formattedValue
        });
    };

    const [openDropdownId, setOpenDropdownId] = useState(null);
    const [openDropdownEtat, setOpenDropdownEtat] = useState(false);

    const toggleDropdown = (id) => {
        if (openDropdownId === id) {
            // Si le menu est déjà ouvert pour cet ID, on le ferme
            setOpenDropdownId(null);
            setOpenDropdownEtat(false)
        } else {
            // Sinon, on ouvre le menu pour cet ID
            setOpenDropdownId(id);
            setOpenDropdownEtat(true);
        }
    };

    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (openDropdownId && dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpenDropdownId(null);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [openDropdownId]);

    const dropdownItemStyle = {
        display: 'block',
        width: '100%',
        padding: '8px 16px',
        textAlign: 'left',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        color: '#333',
        ':hover': {
            backgroundColor: '#f5f5f5'
        }
    };

    const handleRenewSubmit = async (pieceId) => {
        try {
            const pieceData = piecesFormData[pieceId];
            const piece = piecesExpirables.find(p => p.id === pieceId);

            if (!piece || !pieceData) {
                showAlert("Pièce non trouvée", "warning");
                return;
            }

            const aujourdHui = new Date();
            aujourdHui.setHours(0, 0, 0, 0);
            const finValidite = new Date(pieceData.fin_validite);

            // Only keep validation for required fields (expiration date)
            if (!pieceData.fin_validite) {
                showAlert("Veuillez saisir une date d'expiration", "warning");
                return;
            }

            if (finValidite < aujourdHui) {
                showAlert("La date expiration ne peut pas être antérieure à aujourd'hui", "warning");
                return;
            }

            setIsLoading(true);
            const formDataToSend = new FormData();

            formDataToSend.append('piece_id', piece.id);
            formDataToSend.append('fin_validite', pieceData.fin_validite);
            // The document number is still sent, but can be empty
            formDataToSend.append('numero_piece', pieceData.numero_piece || '');

            if (pieceData.fichier) {
                formDataToSend.append('fichier', pieceData.fichier);
            }

            const response = await axios.post(
                `${process.env.REACT_APP_HOTE}/renouveler-piece/`,
                formDataToSend
            );

            if (response.data.success) {
                showAlert(response.data.message || "Pièce renouvelée avec succès", "success");
                fetchPieces();
                // handleCloseRenewModal();
            } else {
                throw new Error(response.data.message || "Erreur inconnue");
            }
        } catch (error) {
            console.error("Erreur détaillée:", error);
            showAlert(error.response?.data?.message || error.message, "danger");
        } finally {
            setIsLoading(false);
        }
    };

    const [showVersionsModal, setShowVersionsModal] = useState(false);
    const [pieceVersions, setPieceVersions] = useState([]);


    const trouverDerniereVersion = (typePiece, idObjet) => {
        const piecesDuMemeType = listePiece.filter(piece =>
            piece.type_piece === typePiece &&
            piece.id_objet === idObjet
        );

        if (piecesDuMemeType.length === 0) return '1';

        const derniereVersion = piecesDuMemeType.reduce((max, piece) => {
            const versionNum = parseInt(piece.version) || 0;
            return versionNum > max ? versionNum : max;
        }, 0);

        return `${derniereVersion + 1}`;
    };

    // const vehiculeAPiecesExpirees = (vehicule) => {
    //     return listePiece.some(p => 
    //         p.numero_immatriculation === vehicule.numero_immatriculation && 
    //         piecesAActions(p) // Utilise la fonction existante qui vérifie si une pièce est expirée
    //     );
    // };
    // const hasAncientVersions = (piece) => {
    //     console.log("anciennes", piece)
    //     // Vérifie si la pièce a des versions antérieures (non actuelles)
    //     return listePiece.some(p => 
    //         p.type_piece === piece.type_piece && 
    //         p.numero_immatriculation === piece.numero_immatriculation && 
    //         !p.est_actuelle
    //     );
    // };
    const hasAncientVersions = (vehicule) => {
        // Vérifie si la version de la pièce est supérieure à 1
        return listePiece.some(p =>
            p.numero_immatriculation === vehicule.numero_immatriculation &&
            parseInt(p.version) > 1
        );
    };
    const hasActions = (vehicule) => {
        const piecesDuVehicule = listePiece.filter(p =>
            p.numero_immatriculation === vehicule.numero_immatriculation
        );

        // Vérifie s'il y a des pièces à renouveler OU des anciennes versions
        return vehiculeAPiecesExpirees(vehicule) || hasAncientVersions(vehicule);
    };

    const [activeTab, setActiveTab] = useState('valides'); // 'valides' ou 'expirees'
    const [validesVersions, setValidesVersions] = useState({});
    const [expireesVersions, setExpireesVersions] = useState({});

    // const handleOpenVersionsModal = async (piece) => {
    //     setOpenDropdownId(null);
    //     setIsLoading(true);

    //     try {
    //         const response = await axios.get(
    //             `${process.env.REACT_APP_HOTE}/toutes-versions-vehicule/${piece.vehicule_id}/`
    //         );

    //         if (response.data.success) {
    //             const aujourdHui = new Date();
    //             aujourdHui.setHours(0, 0, 0, 0);

    //             // Séparer les pièces valides et expirées
    //             const valides = {};
    //             const expirees = {};

    //             response.data.data.forEach(p => {
    //                 let joursRestants = null;
    //                 if (p.fin_validite) {
    //                     try {
    //                         const finValidite = new Date(p.fin_validite);
    //                         joursRestants = Math.floor((finValidite - aujourdHui) / (1000 * 60 * 60 * 24));
    //                     } catch (e) {
    //                         console.error("Erreur de format de date:", p.fin_validite);
    //                     }
    //                 }

    //                 const pieceFormatee = {
    //                     ...p,
    //                     fin_validite: p.fin_validite 
    //                         ? new Date(p.fin_validite).toLocaleDateString('fr-FR') 
    //                         : 'Non défini',
    //                     jours_restants: joursRestants,
    //                     fichier_url: p.fichier_url ? process.env.REACT_APP_HOTE + p.fichier_url : null
    //                 };

    //                 // Grouper par type de pièce
    //                 if (joursRestants !== null && joursRestants >= 0) {
    //                     // Pièce valide
    //                     if (!valides[p.type_piece]) {
    //                         valides[p.type_piece] = [];
    //                     }
    //                     valides[p.type_piece].push(pieceFormatee);
    //                 } else {
    //                     // Pièce expirée
    //                     if (!expirees[p.type_piece]) {
    //                         expirees[p.type_piece] = [];
    //                     }
    //                     expirees[p.type_piece].push(pieceFormatee);
    //                 }
    //             });

    //             // Trier chaque groupe par version
    //             Object.keys(valides).forEach(type => {
    //                 valides[type].sort((a, b) => b.version - a.version);
    //             });
    //             Object.keys(expirees).forEach(type => {
    //                 expirees[type].sort((a, b) => b.version - a.version);
    //             });

    //             setValidesVersions(valides);
    //             setExpireesVersions(expirees);
    //             setPieceVersions(expirees); // Pour compatibilité avec l'ancien code

    //             // Sélectionner la première version valide si disponible
    //             const firstValidType = Object.keys(valides)[0];
    //             if (firstValidType && valides[firstValidType].length > 0) {
    //                 setSelectedVersion(valides[firstValidType][0]);
    //             } else {
    //                 // Sinon sélectionner la première version expirée
    //                 const firstExpiredType = Object.keys(expirees)[0];
    //                 if (firstExpiredType && expirees[firstExpiredType].length > 0) {
    //                     setSelectedVersion(expirees[firstExpiredType][0]);
    //                     setActiveTab('expirees');
    //                 }
    //             }

    //             setShowVersionsModal(true);
    //         } else {
    //             throw new Error(response.data.message || "Erreur lors de la récupération des versions");
    //         }
    //     } catch (error) {
    //         console.error("Erreur:", error);
    //         showAlert(error.message, "danger");
    //     } finally {
    //         setIsLoading(false);
    //     }
    // };
    const handleOpenVersionsModal = async (piece) => {
        setOpenDropdownId(null);
        setIsLoading(true);

        try {
            // Trouver le véhicule correspondant à la pièce
            const vehicule = listePiece.find(v =>
                v.pieces_expirables?.some(p => p.id === piece.id)
            );

            if (!vehicule || !vehicule.id) {
                throw new Error("Véhicule non trouvé");
            }

            const response = await axios.get(
                `${process.env.REACT_APP_HOTE}/toutes-versions-vehicule/${vehicule.id}/`
            );

            if (response.data.success) {
                const aujourdHui = new Date();
                aujourdHui.setHours(0, 0, 0, 0);

                // Séparer les pièces valides et expirées
                const valides = {};
                const expirees = {};

                response.data.data.forEach(p => {
                    let joursRestants = null;
                    if (p.fin_validite) {
                        try {
                            const finValidite = new Date(p.fin_validite);
                            joursRestants = Math.floor((finValidite - aujourdHui) / (1000 * 60 * 60 * 24));
                        } catch (e) {
                            console.error("Erreur de format de date:", p.fin_validite);
                        }
                    }

                    const pieceFormatee = {
                        ...p,
                        fin_validite: p.fin_validite
                            ? new Date(p.fin_validite).toLocaleDateString('fr-FR')
                            : 'Non défini',
                        jours_restants: joursRestants,
                        fichier_url: p.fichier_url ? process.env.REACT_APP_HOTE + p.fichier_url : null
                    };

                    // Grouper par type de pièce
                    if (joursRestants !== null && joursRestants >= 0) {
                        if (!valides[p.type_piece]) {
                            valides[p.type_piece] = [];
                        }
                        valides[p.type_piece].push(pieceFormatee);
                    } else {
                        if (!expirees[p.type_piece]) {
                            expirees[p.type_piece] = [];
                        }
                        expirees[p.type_piece].push(pieceFormatee);
                    }
                });

                // Trier chaque groupe par version
                Object.keys(valides).forEach(type => {
                    valides[type].sort((a, b) => b.version - a.version);
                });
                Object.keys(expirees).forEach(type => {
                    expirees[type].sort((a, b) => b.version - a.version);
                });

                setValidesVersions(valides);
                setExpireesVersions(expirees);
                setPieceVersions(expirees);

                // Sélectionner la première version valide si disponible
                const firstValidType = Object.keys(valides)[0];
                if (firstValidType && valides[firstValidType].length > 0) {
                    setSelectedVersion(valides[firstValidType][0]);
                } else {
                    const firstExpiredType = Object.keys(expirees)[0];
                    if (firstExpiredType && expirees[firstExpiredType].length > 0) {
                        setSelectedVersion(expirees[firstExpiredType][0]);
                        setActiveTab('expirees');
                    }
                }

                setShowVersionsModal(true);
            } else {
                throw new Error(response.data.message || "Erreur lors de la récupération des versions");
            }
        } catch (error) {
            console.error("Erreur:", error);
            showAlert(error.message, "danger");
        } finally {
            setIsLoading(false);
        }
    };

    // Ajoutez cet état avec les autres états
    const [selectedVersion, setSelectedVersion] = useState(null);

    const handleCloseVersionsModal = () => {
        setShowVersionsModal(false);
        setPieceVersions({}); // Changé de [] à {} car c'est maintenant un objet
        setSelectedVersion(null);
    };

    const [showGlossary, setShowGlossary] = useState(false);

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <FaFileAlt size={25} className="mr-2" />
                                    Suivi documents
                                    <span
                                        className="ml-3 toggle-icon"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => setShowInfo(!showInfo)}
                                    >
                                        {showInfo ? <FaChevronUp /> : <FaChevronDown />}
                                    </span>
                                </div>

                                {/* Bouton d'aide complètement à droite */}
                                {/* <button
                                    className="btn btn-link p-0 ml-2"
                                    title="Manuel d'utilisation"
                                    onClick={() => navigate('/Manuel-utilisation-admin', {
                                        state: {
                                            fromModule: 'administration',
                                            fromSection: 'admin-suivi-documents'
                                        }
                                    })}
                                >
                                    <FaQuestionCircle size={18} />
                                </button> */}
                                {/* <button
                                    className="btn btn-link p-0 ml-2"
                                    title="Aide"
                                    onClick={() => setShowGlossary(true)}
                                >
                                    <FaQuestionCircle size={18} />
                                </button> */}
                            </h2>
                            <div className={`info-box p-0 col-lg-6 ${showInfo ? "open" : ""}`}>
                                {/* <small>
                                    <b>Légende : </b><br />
                                    <span className="badge bg-primary ml-2">Valide</span> <span>La pièce est valide et il reste plus de 30 jours avant son expiration. </span>
                                    <span className="badge bg-warning ml-2">30 jours</span> <span>La pièce est valide mais il reste moins de 30 jours avant son expiration. </span>
                                    <span className="badge bg-danger ml-2">Expirée</span> <span>La pièce est expirée, il est nécessaire de la renouveler.</span>
                                </small> */}
                                <small>
                                {/* <b>Légende : </b><br /> */}
                                <table className="table table-bordered text-center">
                                    <thead>
                                    <tr>
                                        <th><span className="badge bg-primary">Valide</span></th>
                                        <th><span className="badge badge-warning">30 jours</span></th>
                                        <th><span className="badge bg-danger">Expirée</span></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td >La pièce est valide et il reste plus de 30 jours avant son expiration.</td>
                                        <td >La pièce est valide mais il reste moins de 30 jours avant son expiration.</td>
                                        <td >La pièce est expirée, il est nécessaire de la renouveler.</td>
                                    </tr>
                                    </tbody>
                                </table>
                                </small>
                            </div>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Menu`}> Accueil</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Admin`}> Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item active">
                                        Suivi documents
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    {alert.message && (
                        <div className={`mt-3 alert alert-${alert.type}`}>
                            {alert.message}
                        </div>
                    )}
                    <div className="wrapper wrapper-content animated fadeInRight mt-3 mt-3">
                        <div className="">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5>Liste des pièces</h5>
                                <div className="d-flex flex-column flex-md-row">
                                    <button
                                        className="btn btn-success mr-2 ms-0 mb-2 mb-md-0 ms-md-2"
                                        onClick={handleAdvancedSearchOpen}
                                    >
                                        <FaSearch style={{ marginRight: '2px' }} /> {" "}
                                        Recherche avancée
                                    </button>
                                    {hasActiveFilters() && (
                                        <Button
                                            variant="secondary"
                                            onClick={() => {
                                                handleResetSearch();
                                                setSearchParams({
                                                    numero_immatriculation: '',
                                                    proprietaire: '',
                                                    numero_piece: '',
                                                    statut: ''
                                                });
                                                setCurrentPage(1);
                                            }}
                                            className="mr-2"
                                        >
                                            <FaArrowRotateLeft style={{ marginRight: '2px' }} /> {" "}
                                            Réinitialiser
                                        </Button>
                                    )}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="ibox">
                                        <div className="ibox-content">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <div className="me-2 d-flex ">
                                                    <select
                                                        value={itemsPerPage}
                                                        onChange={handleItemsPerPageChange}
                                                        className="form-select bg-default p-1"
                                                        style={{
                                                            width: "auto",
                                                            border: "1px black solid",
                                                            borderRadius: "5px",
                                                        }}
                                                    >
                                                        {/* <option value={5}>5</option> */}
                                                        <option value={10}>10</option>
                                                        <option value={20}>20</option>
                                                        <option value={50}>50</option>
                                                    </select>
                                                    <select
                                                        style={{ border: '1px black solid', borderRadius: '5px' }}
                                                        onChange={(e) => handleFilterClick(e.target.value)}
                                                        className="form-select bg-light p-1 ml-2"
                                                        value={currentFilter}
                                                    >
                                                        <option className="text-left" value="">Tout</option>
                                                        <option className="text-left" value="7jrs">A 7 Jours</option>
                                                        <option className="text-left" value="15jrs">A 15 Jours</option>
                                                        <option className="text-left" value="30jrs">A 30 Jours</option>
                                                        <option className="text-left" value="expiree">Expirée</option>
                                                    </select>

                                                </div>

                                                <div className="d-flex align-items-center ">
                                                    <input
                                                        type="text"
                                                        placeholder="Rechercher..."
                                                        className="form-control"
                                                        style={{ maxWidth: "150px", width: "100%" }}
                                                        value={searchTerm}
                                                        onChange={(e) => setSearchTerm(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="table-responsive" style={{
                                                // maxHeight: '500px',  // Hauteur maximale avant d'afficher la scrollbar
                                                // overflowY: 'auto',   // Activation du défilement vertical
                                                // display: 'block'     // Nécessaire pour que overflowY fonctionne
                                                // position: 'relative',
                                                // overflow: 'visible' 
                                            }}>
                                                {isLoadingPieces && (
                                                    <div style={{
                                                        position: 'absolute',
                                                        top: '50%',
                                                        left: '50%',
                                                        transform: 'translate(-50%, -50%)',
                                                        zIndex: 10
                                                    }}>
                                                        <Spinner animation="border" variant="primary" />
                                                        <span className="ms-2">Chargement des données...</span>
                                                    </div>
                                                )}
                                                <table
                                                    className="footable table table-stripped footable-loaded tablet breakpoint"
                                                    style={{ opacity: isLoadingPieces ? 0.5 : 1, textAlign: 'center' }}
                                                    data-page-size="8"
                                                    data-filter="#filter"
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th className="text-secondary text-wrap d-none d-md-table-cell text-left" onClick={() => handleSort("numero_immatriculation")}>
                                                                Immatriculation{" "}
                                                                {sortConfig.key === "numero_immatriculation" && sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th className="text-secondary text-wrap d-none d-md-table-cell text-left" onClick={() => handleSort("proprietaire")}>
                                                                Propriétaire{" "}
                                                                {sortConfig.key === "proprietaire" && sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th className="text-secondary text-wrap d-none d-md-table-cell" onClick={() => handleSort("telephone")}>
                                                                Téléphone{" "}
                                                                {sortConfig.key === "telephone" && sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th
                                                                className="text-secondary text-wrap d-none d-md-table-cell"
                                                                onClick={() => handleSort("piece_Carte d'identité")}
                                                            >
                                                                Pièce d'identité{" "}
                                                                {sortConfig.key === "piece_Carte d'identité" && sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th
                                                                className="text-secondary text-wrap d-none d-md-table-cell"
                                                                onClick={() => handleSort("piece_Carte transport nationale")}
                                                            >
                                                                CT nationale{" "}
                                                                {sortConfig.key === "piece_Carte transport nationale" && sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th
                                                                className="text-secondary text-wrap d-none d-md-table-cell"
                                                                onClick={() => handleSort("piece_Carte transport internationale")}
                                                            >
                                                                CT internationale{" "}
                                                                {sortConfig.key === "piece_Carte transport internationale" && sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th
                                                                className="text-secondary text-wrap d-none d-md-table-cell"
                                                                onClick={() => handleSort("piece_Assurance")}
                                                            >
                                                                Assurance{" "}
                                                                {sortConfig.key === "piece_Assurance" && sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th
                                                                className="text-secondary text-wrap d-none d-md-table-cell"
                                                                onClick={() => handleSort("piece_Visite technique")}
                                                            >
                                                                Visite technique{" "}
                                                                {sortConfig.key === "piece_Visite technique" && sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th
                                                                className="text-secondary text-wrap d-none d-md-table-cell"
                                                                onClick={() => handleSort("piece_TVM")}
                                                            >
                                                                TVM{" "}
                                                                {sortConfig.key === "piece_TVM" && sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            {/* <th className="text-secondary text-wrap d-none d-md-table-cell">Actions</th> */}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {!isLoadingPieces && sortedPieces.slice(indexOfFirstItem, indexOfLastItem).length > 0 ? (
                                                            sortedPieces.slice(indexOfFirstItem, indexOfLastItem).map((vehicule) => (
                                                                <tr key={vehicule.id}>
                                                                    <td className="text-left">
                                                                        {vehicule.numero_immatriculation}
                                                                        <div className="lesInfos">
                                                                            <small>Propriétaire : {vehicule.proprietaire?.nom_complet}</small>
                                                                            <br />
                                                                            <small>Téléphone : {vehicule.proprietaire?.telephone}</small>
                                                                            <br />
                                                                            <small>Pièces expirées :</small>
                                                                            <br />
                                                                            <small>Pièce d'identité : {renderPieceCell(vehicule, "Carte d'identité")}</small>
                                                                            <br />
                                                                            <small>Carte transport nationale : {renderPieceCell(vehicule, "Carte transport nationale")}</small>
                                                                            <br />
                                                                            <small>Carte transport internationale : {renderPieceCell(vehicule, "Carte transport internationale")}</small>
                                                                            <br />
                                                                            <small>Assurance : {renderPieceCell(vehicule, "Assurance")}</small>
                                                                            <br />
                                                                            <small>Visite technique : {renderPieceCell(vehicule, "Visite technique")}</small>
                                                                            <br />
                                                                            <small>TVM : {renderPieceCell(vehicule, "TVM")}</small>
                                                                        </div>
                                                                    </td>
                                                                    {/* <td className="d-none d-md-table-cell">{vehicule.proprietaire}</td>
                                                                            <td className="d-none d-md-table-cell">{vehicule.telephone}</td> */}
                                                                    <td className="d-none d-md-table-cell text-left">{vehicule.proprietaire?.nom_complet}</td>
                                                                    <td className="d-none d-md-table-cell">{vehicule.proprietaire?.telephone}</td>

                                                                    {/* Colonnes pour chaque type de pièce expirable */}
                                                                    <td className="d-none d-md-table-cell">
                                                                        {renderPieceCell(vehicule, "Carte d'identité")}
                                                                    </td>
                                                                    <td className="d-none d-md-table-cell">
                                                                        {renderPieceCell(vehicule, 'Carte transport nationale')}
                                                                    </td>
                                                                    <td className="d-none d-md-table-cell">
                                                                        {renderPieceCell(vehicule, 'Carte transport internationale')}
                                                                    </td>
                                                                    <td className="d-none d-md-table-cell">
                                                                        {renderPieceCell(vehicule, 'Assurance')}
                                                                    </td>
                                                                    <td className="d-none d-md-table-cell">
                                                                        {renderPieceCell(vehicule, 'Visite technique')}
                                                                    </td>
                                                                    <td className="d-none d-md-table-cell">
                                                                        {renderPieceCell(vehicule, 'TVM')}
                                                                    </td>
                                                                    {/* <td style={{ textAlign: 'left' }}>
                                                                        <button
                                                                            className="btn btn-sm d-flex align-items-center"
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                toggleDropdown(vehicule.id);
                                                                            }}
                                                                            style={{
                                                                                padding: '0.25rem 0.5rem',
                                                                                border: '1px solid #ddd',
                                                                                borderRadius: '4px',
                                                                                backgroundColor: '#f8f9fa'
                                                                            }}
                                                                        >
                                                                            <FaEllipsisV className="ms-1" size={12} />
                                                                        </button>

                                                                        {openDropdownId === vehicule.id && (
                                                                            <div
                                                                                ref={dropdownRef}
                                                                                style={{
                                                                                    position: 'fixed',
                                                                                    zIndex: 1000, // Augmentez le z-index si nécessaire
                                                                                    right: '60px',
                                                                                    minWidth: 'auto',
                                                                                    backgroundColor: 'white',
                                                                                    border: '1px solid #ddd',
                                                                                    borderRadius: '4px',
                                                                                    boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
                                                                                    textAlign: 'center'
                                                                                }}
                                                                            >

                                                                                {vehiculeAPiecesExpirees(vehicule) && (
                                                                                    <>
                                                                                        <div style={{ display: 'flex', alignItems: 'center', padding: '8px', textAlign: 'center' }}>
                                                                                            <FaEdit style={{ marginRight: '8px', fontSize: '1.2rem' }} />
                                                                                            <button
                                                                                                style={{
                                                                                                    ...dropdownItemStyle,
                                                                                                    border: 'none',
                                                                                                    background: 'transparent',
                                                                                                    padding: 0,
                                                                                                    fontSize: '0.8rem',
                                                                                                    cursor: 'pointer',
                                                                                                }}
                                                                                                onClick={(e) => {
                                                                                                    e.stopPropagation();
                                                                                                    navigate('/Admin-renouveler-pieces-vehicule', {
                                                                                                        state: {
                                                                                                            vehicule_id: vehicule.id,
                                                                                                            vehiculeData: vehicule,
                                                                                                            piecesExpirables: vehicule.pieces_expirables.filter(p => piecesAActions(p))
                                                                                                        }
                                                                                                    });
                                                                                                    setOpenDropdownId(null);
                                                                                                }}
                                                                                            >
                                                                                                Renouveler
                                                                                            </button>
                                                                                        </div>
                                                                                        <div style={{ borderTop: '1px solid #eee' }} />
                                                                                    </>
                                                                                )}
                                                                                <div style={{ display: 'flex', alignItems: 'center', padding: '8px', textAlign: 'center' }}>
                                                                                    <FaFileAlt style={{ marginRight: '8px', fontSize: '1rem' }} />
                                                                                    <button
                                                                                        style={{
                                                                                            ...dropdownItemStyle,
                                                                                            border: 'none',
                                                                                            background: 'transparent',
                                                                                            padding: 0,
                                                                                            fontSize: '0.8rem',
                                                                                            cursor: 'pointer',
                                                                                        }}
                                                                                        onClick={(e) => {
                                                                                            e.stopPropagation();
                                                                                            navigate('/Admin-consulter-pieces-vehicule', {
                                                                                                state: {
                                                                                                    vehicule_id: vehicule.id,
                                                                                                    vehiculeData: vehicule,
                                                                                                    piecesExpirables: vehicule.pieces_expirables.filter(p => piecesAActions(p))
                                                                                                }
                                                                                            });
                                                                                            setOpenDropdownId(null);
                                                                                        }}
                                                                                    >
                                                                                        Consulter
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </td> */}
                                                                </tr>
                                                            ))
                                                        ) : !isLoadingPieces ? (
                                                            <tr>
                                                                <td colSpan="10">Aucune donnée disponible</td>
                                                            </tr>
                                                        ) : null}
                                                    </tbody>
                                                    {/* </tr>
                                                                    );
                                                                })
                                                        ) : !isLoadingPieces ? (
                                                            <tr>
                                                                <td colSpan="10">Aucun véhicule valide avec pièces expirables trouvé</td>
                                                            </tr>
                                                        ) : null}
                                                    </tbody> */}
                                                </table>
                                            </div>
                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                <div className="dataTables_info" role="status" aria-live="polite">
                                                    {totalItems === 0
                                                        ? ""
                                                        : `Élément ${indexOfFirstItem + 1} à ${Math.min(
                                                            indexOfLastItem,
                                                            totalItems
                                                        )} sur ${totalItems}`}
                                                </div>

                                                <div className="d-flex align-items-center">
                                                    <button
                                                        onClick={() => setCurrentPage(1)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === 1}
                                                    >
                                                        <FaAngleDoubleLeft />
                                                    </button>

                                                    <button
                                                        onClick={handlePreviousPage}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === 1}
                                                    >
                                                        <FaArrowLeft />
                                                    </button>

                                                    {/* Afficher seulement quelques pages autour de la page courante */}
                                                    {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                                                        let pageNum;
                                                        if (totalPages <= 5) {
                                                            pageNum = i + 1;
                                                        } else if (currentPage <= 3) {
                                                            pageNum = i + 1;
                                                        } else if (currentPage >= totalPages - 2) {
                                                            pageNum = totalPages - 4 + i;
                                                        } else {
                                                            pageNum = currentPage - 2 + i;
                                                        }

                                                        return (
                                                            <button
                                                                key={pageNum}
                                                                onClick={() => handlePageChange(pageNum)}
                                                                className={`btn ${currentPage === pageNum ? "btn-secondary" : "btn-light"} mx-1`}
                                                            >
                                                                {pageNum}
                                                            </button>
                                                        );
                                                    })}

                                                    <button
                                                        onClick={handleNextPage}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        <FaArrowRight />
                                                    </button>

                                                    <button
                                                        onClick={() => setCurrentPage(totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        <FaAngleDoubleRight />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="footer text-center">
                        {/* <div className="float-right">
                        10GB of <strong>250GB</strong> Free.
                    </div> */}
                        <Footer/>
                    </div>

                    {/* Modal de recherche avancée */}
                    <Modal show={showAdvancedSearch} onHide={handleAdvancedSearchClose} size="lg">
                        <Modal.Header>
                            <Modal.Title>Recherche avancée</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <form>
                                {/* <div className="row mb-3">
                                    <div className="col-md-6">
                                        <label className="form-label">Type de pièce</label>
                                        <Select
                                            isMulti
                                            name="type_piece"
                                            options={typePieceOptions}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            value={typePieceOptions.filter(option => searchParams.type_piece?.includes(option.value))}
                                            onChange={(selectedOptions) => {
                                                handleSearchParamChange({
                                                    target: {
                                                        name: 'type_piece',
                                                        value: selectedOptions.map(option => option.value)
                                                    }
                                                });
                                            }}
                                            placeholder="Sélectionner un ou plusieurs types de pièce"
                                        />

                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">Version</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="version"
                                            value={searchParams.version}
                                            onChange={handleSearchParamChange}
                                            min="0" // N'autorise que les nombres positifs
                                            onKeyPress={(e) => {
                                                if (!/[0-9]/.test(e.key)) {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />
                                    </div>
                                </div> */}

                                <div className="row mb-3">
                                    <div className="col-md-6">
                                        <label className="form-label">Numéro d'immatriculation</label>
                                        <Select
                                            isClearable
                                            isSearchable
                                            name="numero_immatriculation"
                                            options={listePiece.map(v => ({
                                                value: v.numero_immatriculation,
                                                label: v.numero_immatriculation
                                            }))}
                                            value={searchParams.numero_immatriculation ? {
                                                value: searchParams.numero_immatriculation,
                                                label: searchParams.numero_immatriculation
                                            } : null}
                                            onChange={(selectedOption) => {
                                                setSearchParams({
                                                    ...searchParams,
                                                    numero_immatriculation: selectedOption ? selectedOption.value : ''
                                                });
                                            }}
                                            placeholder="Rechercher une immatriculation..."
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">Propriétaire</label>
                                        <Select
                                            isClearable
                                            isSearchable
                                            name="numero_immatriculation"
                                            options={immatriculations.map(v => ({
                                                value: v.numero_immatriculation,
                                                label: v.numero_immatriculation
                                            }))}
                                            value={searchParams.numero_immatriculation ? {
                                                value: searchParams.numero_immatriculation,
                                                label: searchParams.numero_immatriculation
                                            } : null}
                                            onChange={(selectedOption) => {
                                                setSearchParams({
                                                    ...searchParams,
                                                    numero_immatriculation: selectedOption ? selectedOption.value : ''
                                                });
                                            }}
                                            placeholder="Rechercher une immatriculation..."
                                        />
                                    </div>
                                </div>

                                {/* <div className="row mb-3">
                                    <div className="col-md-6">
                                        <label className="form-label">Téléphone</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="telephone"
                                            value={searchParams.telephone}
                                            onChange={handleSearchParamChange}
                                            min="0" // N'autorise que les nombres positifs
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">Numéro de pièce</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="numero_piece"
                                            value={searchParams.numero_piece}
                                            onChange={handleSearchParamChange}
                                        />
                                    </div>
                                </div> */}

                                {/* <div className="row mb-3">
                                    <div className="col-md-6">
                                        <label className="form-label">Statut</label>
                                        <select
                                            className="form-control"
                                            name="statut"
                                            value={searchParams.statut}
                                            onChange={handleSearchParamChange}
                                        >
                                            <option value="">Tous</option>
                                            <option value="valide">Valide</option>
                                            <option value="expirée">Expirée</option>
                                        </select>
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">Date expiration</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            name="fin_validite"
                                            value={searchParams.fin_validite}
                                            onChange={handleSearchParamChange}
                                        />
                                    </div>
                                </div> */}
                                <div className="row mb-3">
                                    <div className="col-md-12 mb-2">Choisissez des dates pour filtrer sur la période de validité des pièces</div>
                                    <div className="col-md-12 row">
                                        <div className="col-md-6">
                                            <label className="form-label">Date début (période de validité)</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                name="date_debut"
                                                value={searchParams.date_debut}
                                                onChange={handleSearchParamChange}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label">Date fin (période de validité)</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                name="date_fin"
                                                value={searchParams.date_fin}
                                                onChange={handleSearchParamChange}
                                                min={searchParams.date_debut} // La date fin ne peut pas être avant la date début
                                            />
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleAdvancedSearchClose}>
                                Fermer
                            </Button>
                            <Button
                                variant="success"
                                onClick={handleAdvancedSearchSubmit}
                                disabled={isSearching}
                            >
                                {isSearching ? (
                                    <>
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                            className="me-2"
                                        />
                                        Recherche en cours...
                                    </>
                                ) : (
                                    "Rechercher"
                                )}
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    {/* Modal de renouvellement de pièce */}
                    <Modal show={showRenewModal} onHide={handleCloseRenewModal} size="xl">
                        <Modal.Header>
                            <Modal.Title>
                                Renouveler les pièces du véhicule immatriculé {pieceARenouveler?.numero_immatriculation}
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="mb-3">
                                        <h5>Pièces à renouveler</h5>
                                        <div className="list-group">
                                            {piecesExpirables.map(piece => (
                                                <button
                                                    key={piece.id}
                                                    className={`list-group-item list-group-item-action text-start ${pieceARenouveler?.id === piece.id ? 'active' : ''
                                                        }`}
                                                    onClick={() => setPieceARenouveler(piece)}
                                                >
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <span>{piece.type_piece}</span>
                                                        <span className={`badge ${piece.jours_restants === null ? 'bg-danger' : 'bg-warning'
                                                            }`}>
                                                            {piece.jours_restants !== null
                                                                ? `${piece.jours_restants} jours restants`
                                                                : 'Expiré'}
                                                        </span>
                                                    </div>
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-8">
                                    {pieceARenouveler && piecesFormData[pieceARenouveler.id] && (
                                        <>
                                            <div className="card mb-3">
                                                <div className="card-body">
                                                    <h4>Nouvelle pièce {pieceARenouveler.type_piece}</h4>

                                                    <form id="renewForm">
                                                        <div className="row mb-3">
                                                            <div className="col-md-6">
                                                                <label className="form-label">Numéro de pièce</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="numero_piece"
                                                                    value={piecesFormData[pieceARenouveler.id].numero_piece}
                                                                    onChange={(e) => handleDateChange(e, pieceARenouveler.id)}
                                                                />
                                                            </div>
                                                            <div className="col-md-6">
                                                                <label className="form-label">Date expiration</label>
                                                                <span className="text-danger"> *</span>
                                                                <input
                                                                    type="date"
                                                                    className="form-control"
                                                                    name="fin_validite"
                                                                    value={piecesFormData[pieceARenouveler.id].fin_validite}
                                                                    onChange={(e) => handleDateChange(e, pieceARenouveler.id)}
                                                                    min={new Date().toISOString().split('T')[0]}
                                                                    required
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="mb-3">
                                                            <label className="form-label">Document scanné (PDF, JPG, PNG)</label>
                                                            <span className="text-danger"> *</span>
                                                            <input
                                                                type="file"
                                                                className="form-control"
                                                                accept=".pdf,.jpg,.jpeg,.png"
                                                                onChange={(e) => handleFileChange(e, pieceARenouveler.id)}
                                                                required
                                                            />
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>

                                            {/* Nouvelle section pour afficher l'ancienne et la nouvelle pièce côte à côte */}
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="card h-100">
                                                        <div className="card-body">
                                                            <h5>Ancienne pièce</h5>
                                                            {/* <div className="mb-2">
                                                                                    <p><strong>Version:</strong> {pieceARenouveler.version}</p>
                                                                                    <p><strong>Numéro:</strong> {pieceARenouveler.numero_piece || 'Non spécifié'}</p>
                                                                                    <p><strong>Expiration:</strong> {pieceARenouveler.fin_validite || 'Non spécifiée'}</p>
                                                                                </div> */}
                                                            {pieceARenouveler.fichier_url ? (
                                                                <DocumentViewerHistorique
                                                                    fileUrl={pieceARenouveler.fichier_url}
                                                                    fileName={`Ancienne_${pieceARenouveler.type_piece}`}
                                                                    style={{ height: '300px' }}
                                                                />
                                                            ) : (
                                                                <div className="alert alert-info">
                                                                    Aucun document disponible
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="card h-100">
                                                        <div className="card-body">
                                                            <h5>Nouvelle pièce</h5>
                                                            {piecesFormData[pieceARenouveler.id].previewUrl ? (
                                                                <DocumentViewerRenouveler
                                                                    fileUrl={piecesFormData[pieceARenouveler.id].previewUrl}
                                                                    fileType={piecesFormData[pieceARenouveler.id].fichier?.type}
                                                                    fileName={`Nouveau_${pieceARenouveler.type_piece}`}
                                                                    style={{ height: '300px' }}
                                                                />
                                                            ) : (
                                                                <div className="d-flex justify-content-center align-items-center" style={{ height: '300px' }}>
                                                                    <p>Aucun document sélectionné</p>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseRenewModal} disabled={isLoading}>
                                <strong>Fermer</strong>
                            </Button>
                            <Button
                                variant="success"
                                onClick={() => handleRenewSubmit(pieceARenouveler.id)}
                                disabled={isLoading || !pieceARenouveler}
                            >
                                {isLoading
                                    ? `Enregistrement...`
                                    : <strong>Enregistrer</strong>}
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    {/* Modal des anciennes versions */}
                    {/* <Modal show={showVersionsModal} onHide={handleCloseVersionsModal} size="xl">
                        <Modal.Header >
                            <Modal.Title>
                                Consultation des pièces - {selectedVersion?.numero_immatriculation || pieceARenouveler?.numero_immatriculation}
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {isLoading ? (
                                <div className="text-center">
                                    <Spinner animation="border" />
                                    <p>Chargement des données...</p>
                                </div>
                            ) : (
                                <div>
                                    <ul className="nav nav-tabs">
                                        <li className="nav-item">
                                            <button
                                                className={`nav-link ${activeTab === 'valides' ? 'active' : ''}`}
                                                onClick={() => {
                                                    setActiveTab('valides');
                                                    // Réinitialiser la sélection lorsqu'on change d'onglet
                                                    const firstValidType = Object.keys(validesVersions)[0];
                                                    if (firstValidType && validesVersions[firstValidType].length > 0) {
                                                        setSelectedVersion(validesVersions[firstValidType][0]);
                                                    } else {
                                                        setSelectedVersion(null);
                                                    }
                                                }}
                                            >
                                                Pièces valides
                                            </button>
                                        </li>
                                        <li className="nav-item">
                                            <button
                                                className={`nav-link ${activeTab === 'expirees' ? 'active' : ''}`}
                                                onClick={() => {
                                                    setActiveTab('expirees');
                                                    // Réinitialiser la sélection lorsqu'on change d'onglet
                                                    const firstExpiredType = Object.keys(pieceVersions)[0];
                                                    if (firstExpiredType && pieceVersions[firstExpiredType].length > 0) {
                                                        setSelectedVersion(pieceVersions[firstExpiredType][0]);
                                                    } else {
                                                        setSelectedVersion(null);
                                                    }
                                                }}
                                            >
                                                Historique des pièces expirées
                                            </button>
                                        </li>
                                    </ul>

                                    <div className="tab-content mt-3">
                                        {activeTab === 'valides' ? (
                                            <div className="tab-pane fade show active">
                                                {validesVersions && Object.keys(validesVersions).length > 0 ? (
                                                    <div className="row">
                                                        <div className="col-md-3">
                                                            <div className="list-group">
                                                                {Object.keys(validesVersions).map(typePiece => (
                                                                    validesVersions[typePiece] && validesVersions[typePiece].length > 0 && (
                                                                        <button
                                                                            key={typePiece}
                                                                            className="list-group-item list-group-item-action"
style={{
  backgroundColor: selectedVersion?.type_piece === typePiece ? '#f0f0f0' : '',
  color: selectedVersion?.type_piece === typePiece ? '#000' : '',
}}
                                                                            onClick={() => setSelectedVersion(validesVersions[typePiece][0])}
                                                                        >
                                                                            <div className="d-flex justify-content-between">
                                                                                <span>{typePiece}</span>
                                                                            </div>
                                                                        </button>
                                                                    )
                                                                ))}
                                                            </div>
                                                        </div>
                                                        <div className="col-md-9">
                                                            {selectedVersion && validesVersions[selectedVersion.type_piece] ? (
                                                                <>
                                                                    <div className="row d-flex justify-content-between">
                                                                        <div className="col-4">
                                                                            <p><strong>Numéro de pièce :</strong> {selectedVersion.numero_piece || 'Non spécifié'}</p>
                                                                        </div>
                                                                        <div className="col-4 d-flex align-items-center">
                                                                            <p><strong>Date expiration :</strong> {selectedVersion.fin_validite || 'Non spécifiée'}</p>
                                                                        </div>
                                                                        <div className="col-4">
                                                                            {(selectedVersion.jours_restants !== null && selectedVersion.jours_restants > 1) && (
                                                                                <p>
                                                                                    <strong>Jours restants : </strong>
                                                                                    <span className={selectedVersion.jours_restants <= 30 ? 'text-danger' : 'text-success'}>
                                                                                        {selectedVersion.jours_restants} jours
                                                                                    </span>
                                                                                </p>
                                                                            )}
                                                                            {(selectedVersion.jours_restants === 1 || selectedVersion.jours_restants === 0) && (
                                                                                <p>
                                                                                    <strong>Jours restants : </strong>
                                                                                    <span className={selectedVersion.jours_restants <= 30 ? 'text-danger' : 'text-success'}>
                                                                                        {selectedVersion.jours_restants} jour
                                                                                    </span>
                                                                                </p>
                                                                            )}
                                                                        </div>
                                                                    </div>

                                                                    {selectedVersion.fichier_url ? (
                                                                        <DocumentViewerHistorique
                                                                            fileUrl={selectedVersion.fichier_url}
                                                                            fileName={`${selectedVersion.type_piece}_v${selectedVersion.version}`}
                                                                        />
                                                                    ) : (
                                                                        <div className="alert alert-info">
                                                                            Aucun document disponible pour cette version
                                                                        </div>
                                                                    )}
                                                                </>
                                                            ) : (
                                                                <div className="d-flex justify-content-center align-items-center" style={{ height: '300px' }}>
                                                                    <p>Aucune pièce valide sélectionnée</p>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="text-center">
                                                        Aucune pièce valide disponible
                                                    </div>
                                                )}
                                            </div>
                                        ) : (
                                            <div className="tab-pane fade show active">
                                                {pieceVersions && Object.keys(pieceVersions).length > 0 ? (
                                                    <div className="row">
                                                        <div className="col-md-3">
                                                            <div className="list-group">
                                                                {Object.keys(pieceVersions).map(typePiece => (
                                                                    pieceVersions[typePiece] && pieceVersions[typePiece].length > 0 && (
                                                                        <button
                                                                            key={typePiece}
                                                                            className="list-group-item list-group-item-action"
style={{
  backgroundColor: selectedVersion?.type_piece === typePiece ? '#f0f0f0' : '',
  color: selectedVersion?.type_piece === typePiece ? '#000' : '',
}}
                                                                            onClick={() => setSelectedVersion(pieceVersions[typePiece][0])}
                                                                        >
                                                                            <div className="d-flex justify-content-between">
                                                                                <span>{typePiece}</span>
                                                                            </div>
                                                                        </button>
                                                                    )
                                                                ))}
                                                            </div>
                                                        </div>
                                                        <div className="col-md-9">
                                                            {selectedVersion && pieceVersions[selectedVersion.type_piece] ? (
                                                                <>
                                                                    <div className="row d-flex justify-content-between mb-3">
                                                                        <div className="col-4">
                                                                            <p><strong>Numéro de pièce :</strong> {selectedVersion.numero_piece || 'Non spécifié'}</p>
                                                                        </div>
                                                                        <div className="col-4">
                                                                            <p><strong>Date expiration :</strong> {selectedVersion.fin_validite || 'Non spécifiée'}</p>
                                                                        </div>
                                                                        {pieceVersions[selectedVersion.type_piece]?.length > 0 && (
                                                                            <div className="col-4">
                                                                                <select
                                                                                    className="form-select"
                                                                                    value={selectedVersion.id}
                                                                                    onChange={(e) => {
                                                                                        const selected = pieceVersions[selectedVersion.type_piece]
                                                                                            .find(v => v.id === parseInt(e.target.value));
                                                                                        setSelectedVersion(selected);
                                                                                    }}
                                                                                >
                                                                                    {pieceVersions[selectedVersion.type_piece].map(version => (
                                                                                        <option
                                                                                            key={version.id}
                                                                                            value={version.id}
                                                                                        >
                                                                                            Version {version.version} - {version.fin_validite || 'Sans date'}
                                                                                        </option>
                                                                                    ))}
                                                                                </select>
                                                                            </div>
                                                                        )}
                                                                    </div>

                                                                    {selectedVersion.fichier_url ? (
                                                                        <DocumentViewerHistorique
                                                                            fileUrl={selectedVersion.fichier_url}
                                                                            fileName={`${selectedVersion.type_piece}_v${selectedVersion.version}`}
                                                                        />
                                                                    ) : (
                                                                        <div className="alert alert-info">
                                                                            Aucun document disponible pour cette version
                                                                        </div>
                                                                    )}
                                                                </>
                                                            ) : (
                                                                <div className="d-flex justify-content-center align-items-center" style={{ height: '300px' }}>
                                                                    <p>Aucune pièce expirée sélectionnée</p>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="text-center">
                                                        Aucune pièce expirée dans l'historique
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseVersionsModal}>
                                Fermer
                            </Button>
                        </Modal.Footer>
                    </Modal> */}
                    {/* Modal des anciennes versions */}
                    <Modal show={showVersionsModal} onHide={handleCloseVersionsModal} size="xl">
                        <Modal.Header>
                            <Modal.Title>
                                Consultation des pièces - {selectedVersion?.numero_immatriculation || pieceARenouveler?.numero_immatriculation}
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {isLoading ? (
                                <div className="text-center">
                                    <Spinner animation="border" />
                                    <p>Chargement des données...</p>
                                </div>
                            ) : (
                                <div>
                                    <ul className="nav nav-tabs">
                                        <li className="nav-item">
                                            <button
                                                className={`nav-link ${activeTab === 'valides' ? 'active' : ''}`}
                                                onClick={() => {
                                                    setActiveTab('valides');
                                                    const firstValidType = Object.keys(validesVersions)[0];
                                                    if (firstValidType && validesVersions[firstValidType].length > 0) {
                                                        setSelectedVersion(validesVersions[firstValidType][0]);
                                                    } else {
                                                        setSelectedVersion(null);
                                                    }
                                                }}
                                            >
                                                Pièces valides
                                            </button>
                                        </li>
                                        <li className="nav-item">
                                            <button
                                                className={`nav-link ${activeTab === 'expirees' ? 'active' : ''}`}
                                                onClick={() => {
                                                    setActiveTab('expirees');
                                                    const firstExpiredType = Object.keys(pieceVersions)[0];
                                                    if (firstExpiredType && pieceVersions[firstExpiredType].length > 0) {
                                                        setSelectedVersion(pieceVersions[firstExpiredType][0]);
                                                    } else {
                                                        setSelectedVersion(null);
                                                    }
                                                }}
                                            >
                                                Historique des pièces expirées
                                            </button>
                                        </li>
                                    </ul>

                                    <div className="tab-content mt-3">
                                        {activeTab === 'valides' ? (
                                            <div className="tab-pane fade show active">
                                                {validesVersions && Object.keys(validesVersions).length > 0 ? (
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <div className="list-group mb-3">
                                                                {Object.keys(validesVersions).map(typePiece => {
                                                                    const firstVersion = validesVersions[typePiece][0];

                                                                    return (
                                                                        validesVersions[typePiece] && validesVersions[typePiece].length > 0 && (
                                                                            <button
                                                                                key={typePiece}
                                                                                className="list-group-item list-group-item-action"
                                                                                style={{
                                                                                    backgroundColor: selectedVersion?.type_piece === typePiece ? '#f0f0f0' : '',
                                                                                    color: selectedVersion?.type_piece === typePiece ? '#000' : '',
                                                                                }}
                                                                                onClick={() => setSelectedVersion(firstVersion)}
                                                                            >
                                                                                <div>
                                                                                    <span>{typePiece}</span>
                                                                                    <small>
                                                                                        <div className="mb-2">
                                                                                            {firstVersion.numero_piece || 'Non spécifié'} <br />
                                                                                            <strong>Version:</strong> {firstVersion.version} <br />
                                                                                            <strong>Expiration:</strong> {firstVersion.fin_validite || 'Non spécifiée'} <br />
                                                                                            {firstVersion.jours_restants !== null && (
                                                                                                <p>
                                                                                                    <strong>Jours restants : </strong>
                                                                                                    <span className={`ms-2 ${firstVersion.jours_restants <= 30 ? 'badge badge-danger' : 'badge badge-primary'}`}>
                                                                                                        {firstVersion.jours_restants} jour{firstVersion.jours_restants !== 1 ? 's' : ''}
                                                                                                    </span>
                                                                                                </p>
                                                                                            )}
                                                                                        </div>
                                                                                    </small>
                                                                                </div>
                                                                            </button>
                                                                        )
                                                                    );
                                                                })}

                                                            </div>
                                                        </div>

                                                        <div className="col-md-8">
                                                            {selectedVersion?.fichier_url ? (
                                                                <DocumentViewerHistorique
                                                                    fileUrl={selectedVersion.fichier_url}
                                                                    fileName={`${selectedVersion.type_piece}_v${selectedVersion.version}`}
                                                                />
                                                            ) : (
                                                                <div className="mt-3">
                                                                    Aucun document disponible pour cette version
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="text-center mt-3">
                                                        Aucune pièce valide disponible
                                                    </div>
                                                )}
                                            </div>
                                        ) : (
                                            <div className="tab-pane fade show active">
                                                {pieceVersions && Object.keys(pieceVersions).length > 0 ? (
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <div className="list-group mb-3">
                                                                {Object.keys(pieceVersions).map(typePiece => {
                                                                    const firstVersion = pieceVersions[typePiece][0];

                                                                    return (
                                                                        pieceVersions[typePiece] && pieceVersions[typePiece].length > 0 && (
                                                                            <button
                                                                                key={typePiece}
                                                                                className="list-group-item list-group-item-action"
                                                                                style={{
                                                                                    backgroundColor: selectedVersion?.type_piece === typePiece ? '#f0f0f0' : '',
                                                                                    color: selectedVersion?.type_piece === typePiece ? '#000' : '',
                                                                                }}
                                                                                onClick={() => setSelectedVersion(firstVersion)}
                                                                            >
                                                                                <div className="">
                                                                                    <span>{typePiece}</span>
                                                                                    <small>
                                                                                        <div className="mb-2">
                                                                                            <strong>Numéro :</strong>{firstVersion.numero_piece || 'Non spécifié'} <br />
                                                                                            <strong>Version :</strong> {firstVersion.version} <br />
                                                                                            <strong>Expiration :</strong> {firstVersion.fin_validite || 'Non spécifiée'}
                                                                                        </div>
                                                                                    </small>
                                                                                </div>
                                                                            </button>
                                                                        )
                                                                    );
                                                                })}

                                                            </div>
                                                        </div>

                                                        <div className="col-md-8"
                                                            style={{ height: '100%' }}
                                                        >
                                                            {selectedVersion?.fichier_url ? (
                                                                <DocumentViewerHistorique
                                                                    fileUrl={selectedVersion.fichier_url}
                                                                    fileName={`${selectedVersion.type_piece}_v${selectedVersion.version}`}
                                                                />
                                                            ) : (
                                                                <div className="alert alert-info mt-3">
                                                                    Aucun document disponible pour cette version
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="text-center mt-3">
                                                        Aucune pièce expirée dans l'historique
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseVersionsModal}>
                                Fermer
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </div>
            <GlossaireSidebar isOpen={showGlossary} onClose={() => setShowGlossary(false)} />
        </div>
    );
};
export default Listes_pieces